/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('core/overlay-screen',['require','jquery','core/base-screen'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var BaseScreen = require('core/base-screen');

  /*****************************************************************************************************************///}

  var OverlayScreen = BaseScreen.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    closeBtn: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    finish: function()
    {
      this.page.finish();
      this.enableCloseButton();
    },

    /*override setupNextButton: function()
    {
      if (this.mc.next_btn_mc)
      {
        this.nextButton = new Button(this.mc.next_btn_mc);
        this.nextButton.setup();
        this.nextButton.onClick = this.nextClicked;
      }
      else
      {
        // overlay screen do not auto generate next button
      }
    }*/

    setInterface: function()
    {
      // nothing by default
    },

    onBeforeShow: function()
    {
      //console.log('OverlayScreen::ready');

      this.setupCloseBtn();
    },

    setupCloseBtn: function()
    {
      this.closeBtn = this.$el.find('[data-id=close-btn]');
      this.disableCloseButton();
    },

    enableCloseButton: function()
    {
      this.closeBtn.one('click', $.proxy(this.onCloseButtonClickHandler, this));
      this.closeBtn.removeClass('disabled');
    },

    disableCloseButton: function()
    {
      this.closeBtn.off('click');
      this.closeBtn.addClass('disabled');
    },

    onCloseButtonClickHandler: function($e, $cb)
    {
      this.disableCloseButton();
      this.closeOverlay();
    },

    closeOverlay: function()
    {
      this.radio.trigger('page.overlay.close');
      //mc.dispatchEvent(new NLEvent(NLEvent.CLOSE_OVERLAY));
    }

  /*****************************************************************************************************************///}

  });

  return OverlayScreen;

});

